export default __webpack_public_path__ + "static/media/working-forms-1.5x.a2ecfdfa.png";